const buttonVariants = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	GHOST: 'ghost',
	TEXT: 'text',
	CAMPAIGN: 'campaign',
};

export default buttonVariants;
